import { render, staticRenderFns } from "./Hoverable.vue?vue&type=template&id=2d0fe3b8&"
import script from "./Hoverable.vue?vue&type=script&lang=js&"
export * from "./Hoverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports